<template>
    <main id="main">
        <section id="services" :class="['pb-1', 'mb-1']">
            <div :class="['container']">
                <div :class="['row']">
                    <div :class="['col-lg-12', 'col-md-12', 'icon-box']">
                        <div :class="['card', 'borderTopCard', 'shadow-sm']" >
                            <div :class="['card-body', 'pt-2']">
                                <h4 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-1', 'mt-3']">Contáctenos:</h4>
                                <br>
                                <div v-for="(val, key) in empresa.sucursal" :key="key">
                                    <h3>{{val.sucursal}}</h3>
                                    <div :class="['line-divider-left']"></div>

                                    <div :class="['row', 'p-3']">
                                        <div :class="['col-lg-6']">	
                                            <div :class="['row']">
                                                <div :class="['col-lg-2', 'my-auto', 'bg_color_drasam', 'border-radius']">
                                                    <i :class="['icofont-telephone', 'icofont-4x']"></i> 
                                                </div>

                                                <div :class="['col-lg-10']"> 
                                                    <div :class="['h-100', 'borderGreen']" >
                                                        <b>Telefonos</b>
                                                        <p>{{val.telefonos}}</p> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div :class="['col-lg-6']">
                                            <div :class="['row']">
                                                <div :class="['col-lg-2', 'my-auto', 'bg_color_drasam', 'border-radius']">
                                                    <i :class="['icofont-email', 'icofont-4x']"></i> 
                                                </div>
                                                
                                                <div :class="['col-lg-10']"> 
                                                    <div :class="['h-100', 'borderGreen']" >   
                                                        <b>Correo</b>
                                                        <p>{{empresa.email}}</p> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div :class="['col-lg-6', 'mt-2']">
                                            <div :class="['row']">
                                                <div :class="['col-lg-2', 'my-auto', 'bg_color_drasam', 'border-radius']">
                                                    <i :class="['icofont-institution', 'icofont-4x']"></i> 
                                                </div>
                                                
                                                <div :class="['col-lg-10']"> 
                                                    <div :class="['h-100', 'borderGreen']" >
                                                        <b>Direccion</b>
                                                        <p>{{val.direccion}}</p> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>    

                                        <div :class="['col-lg-6', 'mt-2']">
                                            <div :class="['row']">
                                                <div :class="['col-lg-2', 'my-auto', 'bg_color_drasam', 'border-radius']"> 
                                                    <i :class="['icofont-clock-time', 'icofont-4x']"></i> 
                                                </div>
                                            
                                                <div :class="['col-lg-10']">
                                                    <div :class="['h-100', 'borderGreen']" >
                                                        <b>Horario</b>
                                                        <p>{{val.horario_atencion}}</p> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>    	     	
                                    </div>

                                    <hr>
                                    <div :class="['row']">
                                        <div :class="['col-lg-12']" > 
                                            <h4>Ubíquenos</h4>
                                            <div :class="['line-divider-left']"></div>
                                            <div :class="[]">
                                                <iframe v-if="val.sucursal=='TARAPOTO'" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Jr.%20Angel%20Delgado%20Morey%20Nro.%20435%20(Altura%20Cdra%2015%20Jr.%20Leguia.)%20-%20Tarapoto%20-%20San%20Martin,%20Per%C3%BA+(Direcci%C3%B3n%20Regional%20de%20Agricultura%20San%20Mart%C3%ADn)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" frameborder="0" style="border:0" allowfullscreen="" :class="['w-100', 'vh-75']" ></iframe>
                                                <iframe v-else src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3967.725976538638!2d-76.97224185263927!3d-6.032294942227766!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sJr.%20Alonso%20de%20Alvarado%20538%20-%20Moyobamba%20-%20San%20Martin%20-%20Per%C3%BA!5e0!3m2!1ses!2spe!4v1631817679401!5m2!1ses!2spe" frameborder="0" style="border:0" allowfullscreen="" :class="['w-100', 'vh-75']" ></iframe>
                                            </div>
                                        </div>
                                    </div>

                                    <br><br>
                                    <hr>
                                </div>

                                <hr>
                                <div :class="['row']">
                                    <div :class="['col-lg-12']" > 
                                            <h4 :class="['mb-1']">Dejenos un mensaje</h4>
                                            <div :class="['line-divider-left']"></div>
                                            <form novalidate="novalidate" :class="['needs-validation', 'was-validated']">
                                                <div :class="['row', 'form-group']">
                                                    <div :class="['col']">
                                                        <label for="">Nombres</label>
                                                        <input type="text" :class="['form-control']" required="" v-model="form.nombres" ref="nombres" placeholder="Escriba sus nombres completo">
                                                    </div>

                                                    <div :class="['col']">
                                                        <label for=" ">Apellidos</label>
                                                    <input type="text" :class="['form-control']"  required="" v-model="form.apellidos" ref="apellidos" placeholder="Escriba sus apellidos completos">
                                                    </div>
                                                </div>

                                                <div :class="['row', 'form-group']">
                                                    <div :class="['col']">
                                                        <label for="">Nro Documento</label>
                                                        <input type="text" :class="['form-control']" required="" v-model="form.nro_documento" maxlength="8" ref="nro_documento" placeholder="Escriba su Nro Doc" @keypress="isNumber($event)">
                                                    </div>
                                                    
                                                    <div :class="['col']">
                                                        <label for="">Telefono</label>
                                                        <input type="text" :class="['form-control']" v-model="form.telefono" ref="telefono" placeholder="Escriba su Nro de Telefono" @keypress="isNumber($event)">
                                                    </div>
                                                </div>

                                                <div :class="['form-group', '']">
                                                    <label for=" ">Correo</label>
                                                    <input type="email" :class="['form-control']" required="" v-model="form.correo" ref="correo" placeholder="Escriba su correo electronico">
                                                </div>
                                                            
                                                <div :class="['form-group']">
                                                    <label>Mensaje</label>
                                                    <textarea :class="['form-control']" required="" v-model="form.mensaje" ref="mensaje" rows="3" placeholder="Escriba su mensaje"></textarea>
                                                </div>

                                                <div class="form-group">
                                                    <button type="button" @click="enviarMail" :class="['btn', 'btn-success', 'align-center', 'w-100']"> Enviar </button>
                                                </div>

                                                <div v-if="errors.length" :class="['form-group']">
                                                    <p style="color:red" >
                                                        <b>Por favor corrija los siguientes Errores:</b>
                                                        <ul>
                                                            <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
                                                        </ul>
                                                    </p>
                                                </div>
                                            </form>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';

    export default {
        name: 'Contactenos',
        computed:{
            ...mapState(['loading','globales','empresa']),
        },
        mounted(){
            this.loadObjEmpresa();
            document.title = "Contactenos || "+(this.empresa.abreviatura);
        },
        data(){
            return{
                errors: [],
                form:{
                    nombres:"",
                    apellidos:"",
                    nro_documento:"",
                    telefono:"",
                    correo:"",
                    mensaje:"",
                },
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
            enviarMail(){
                var self = this;
                this.errors = [];
                if(this.form.nombres==""){
					this.$refs.nombres.focus();
                    this.errors.push("El nombre es obligatorio.");
					return;
				}

                if(this.form.apellidos==""){
					this.$refs.apellidos.focus();
                    this.errors.push("Los apellidos es obligatorio.");
					return;
				}
                
                if(this.form.nro_documento==""){
					this.$refs.nro_documento.focus();
                    this.errors.push("El numero de documento es obligatorio.");
					return;
				}
                
                if(this.form.correo==""){
					this.$refs.correo.focus();
                    this.errors.push("El correo electronico es obligatorio.");
					return;
				}else if(!this.validEmail(this.form.correo)){
                    this.$refs.correo.focus();
                    this.errors.push('El correo electrónico debe ser válido.');
                    return;
                }

                if(this.form.mensaje==""){
					this.$refs.mensaje.focus();
                    this.errors.push("El mensaje es obligatorio.");
					return;
				}

                self.setLoading(true);
				let formData = new FormData();
				formData.append("firmante", this.form.nombres+ ' '+ this.form.apellidos);
                formData.append("tipo_persona", "NATURAL");
                formData.append("cargo", "");
                formData.append("correo", this.form.correo);
                formData.append("tipo_doc_solicitante", "DNI");
                formData.append("nro_doc_solicitante", this.form.nro_documento);
                formData.append("asunto", this.form.mensaje);

                this.$http.post('webserviceserver/contactenos_mail', formData).then((res)=>{
				   if(res.data.status){
						this.alertSuccess(res.data.msg, function(){
						   location.reload();
					   });
				   }else{
					   this.alertWarning(res.data.msg, function(){
						   location.reload();
					   });
				   }
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
        },
    }
</script>

<style scoped>
    .vh-75{
        height: 75vh !important;
    }
</style>